export default __webpack_public_path__ + "static/media/hht2_ep13_timeline_q02_a.3a4112f1.png";